export const isDevelopmentEnvironment = (): boolean => {
	return import.meta.env.VITE_RUN_ENV === 'development';
};
